import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const AfectacionCompraFormGroup = ({
  values,
  setValues,
  iError,
  iTouched,
  fIsSubmitting,
  afectacionesCompras
}) => {
  React.useEffect(() => {
    if (afectacionesCompras.length === 1) {
      values._idAfectacionCompra = afectacionesCompras[0]._id
      setValues(values)
    }
  }, [afectacionesCompras, values, setValues])

  return (
    <Form.Group>
      <Form.Label
        text='COMPRAS'
        htmlFor='select-afectacionesCompras'
        sm={2}
        md={3}
        lg={2}
        alignRightAt='sm'
      />
      <Col sm={10} md={9} lg={10}>
        <Field name='afectacionCompra'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-afectacionesCompras'
            >
              <option value=''>Seleccionar</option>
              {afectacionesCompras &&
                afectacionesCompras.map((val, key) => (
                  <option key={key} value={val._id}>
                    {val.nombre}
                  </option>
                ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(AfectacionCompraFormGroup)
